import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  staticRoutes: string[];
  children: ReactNode;
};

// Fades the incoming route group in (opacity 0 -> 1) on navigation. The group
// is the pathname for static routes, or the constant 'main' for the scroll
// scene — so / <-> /decks share one group and never remount the Canvas,
// leaving the existing 3D PageTransitionOverlay untouched.
export function RouteFade({ staticRoutes, children }: Props) {
  const { pathname } = useLocation();
  // Strip a trailing slash so "/cards/guidance/" still matches "/cards/guidance"
  // (some servers 301 to the slash form) and shares one fade group.
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const routeGroup = staticRoutes.includes(normalized) ? normalized : 'main';

  return (
    <div key={routeGroup} className="route-fade">
      {children}
    </div>
  );
}
